import { http } from '@/http'
import { imgServe } from '@/imageServe'

const PATH = 'app/rcd/'

class RcdService {
  static async getAllUnidades () {
    return http.get(PATH.concat('unidades'))
  }

  static async registerUnidade (data) {
    return http.post(PATH.concat('new-unidade'), data)
  }

  static async destroyUnidade (id) {
    return http.delete(PATH.concat('unidade/').concat(id))
  }

  static async getUnidadeById (id) {
    return http.get(PATH.concat('unidade/').concat(id))
  }

  static async updateUnidade (data, id) {
    return http.post(PATH.concat('update-unidade/').concat(id), data)
  }

  static async getAllSectors () {
    return http.get(PATH.concat('sectors'))
  }

  static async getSectorById (id) {
    return http.get(PATH.concat('sector/').concat(id))
  }

  static async registerSector (data) {
    return http.post(PATH.concat('new-sector'), data)
  }

  static async updateSector (data, id) {
    return http.post(PATH.concat('update-sector/').concat(id), data)
  }

  static async destroySector (id) {
    return http.delete(PATH.concat('sector/').concat(id))
  }

  static async allRelatos (data) {
    return http.get(PATH.concat('relatos'), data)
  }

  static async registerRelato (data) {
    return http.post(PATH.concat('new-relato'), data)
  }

  static async updateRelato (id, data) {
    return http.put(PATH.concat('update-status/').concat(id), data)
  }

  static async removeRelato (id) {
    return http.delete(PATH.concat('destroy-relato/').concat(id))
  }

  static async getAllDocs () {
    return http.get(PATH.concat('all'))
  }

  static async getEmployeesByCombo () {
    return http.get(PATH.concat('employees'))
  }

  static async getAfastamentoCombo () {
    return http.get(PATH.concat('afastamento-combo'))
  }

  static async register (itensBody) {
    return http.post(PATH.concat('register-document'), itensBody)
  }

  static async uploadFile (doc) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem('__company')
      }
    }

    return imgServe.post('new-file', { file: doc }, headers)
  }

  static async removeDocRegister (id) {
    return http.patch(PATH.concat(id).concat('/remove'))
  }

  static async removeDoc (imgPath) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company_path: imgPath,
        __company: localStorage.getItem('__company')
      }
    }

    return imgServe.delete('remove', headers)
  }
}

export default RcdService
